module.exports = __webpack_public_path__ + "img/地骨皮.0d6decde.jpg";